import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.market.info');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

type InfoSectionKey = 'notice' | 'process' | 'business' | 'member-news';

interface InfoSection {
    key: InfoSectionKey;
    title: string;
    description: string;
    statusMessage: string;
}

interface NoticeAttachment {
    id: string;
    name: string;
    size: number;
    mime: string;
    downloadUrl: string;
}

interface ProcedureBlock {
    title: string;
    actor: string;
    details: string[];
}

interface ProcedureFeeGroup {
    title: string;
    note: string;
    paid: boolean;
    items: Array<{ title: string; detail: string }>;
}

interface MarketNotice {
    id: string;
    title: string;
    content: string;
    procedureKind?: 'general' | 'services' | 'steps' | 'fees' | 'text';
    authorName: string;
    pinned: boolean;
    status: string;
    attachments: NoticeAttachment[];
    createdAt: string;
    updatedAt: string;
    linkUrl: string;
    linkLabel: string;
}

interface MarketBusinessInfo {
    id: string;
    organization: string;
    title: string;
    category: string;
    content: string;
    authorName: string;
    pinned: boolean;
    status: string;
    attachments: NoticeAttachment[];
    createdAt: string;
    updatedAt: string;
    linkUrl: string;
    linkLabel: string;
}

interface BusinessInfoForm {
    organization: string;
    title: string;
    category: string;
    content: string;
    pinned: boolean;
}

interface MemberMedia {
    id: string;
    name: string;
    size: number;
    mime: string;
    index: number;
    downloadUrl: string;
}

interface MarketMemberNews {
    id: string;
    companyName: string;
    region: string;
    industry: string;
    summary: string;
    representative: string;
    address: string;
    contact: string;
    introduction: string;
    achievements: string;
    recentNews: string;
    homepage: string;
    authorName: string;
    pinned: boolean;
    status: string;
    photos: MemberMedia[];
    attachments: MemberMedia[];
    createdAt: string;
    updatedAt: string;
}

interface MemberNewsForm {
    companyName: string;
    region: string;
    industry: string;
    summary: string;
    representative: string;
    address: string;
    contact: string;
    introduction: string;
    achievements: string;
    recentNews: string;
    homepage: string;
    pinned: boolean;
}

@Component({
    selector: 'wiz-page-market-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.market.info/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.member-news-section {
  display: grid;
  gap: 20px;
}

.member-news-browser {
  overflow: hidden;
  padding: 28px 30px 30px;
  border: 1px solid #dbe5e1;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 16px 40px rgba(26, 58, 50, 0.06);
}

.member-news-browser-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 26px;
}
.member-news-browser-head h2 {
  margin-top: 7px;
  color: #18231f;
  font-size: 20px;
  font-weight: 780;
  letter-spacing: -0.025em;
}
.member-news-browser-head p {
  max-width: 660px;
  margin-top: 7px;
  color: #697a73;
  font-size: 12px;
  line-height: 1.7;
}

.member-news-kicker {
  color: #397842;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.14em;
}

.member-news-count {
  flex: 0 0 auto;
  padding: 8px 11px;
  border: 1px solid #dce8dc;
  border-radius: 999px;
  color: #47704e;
  background: #f4f8f1;
  font-size: 10px;
  font-weight: 760;
}

.member-news-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.member-news-card {
  display: flex;
  min-width: 0;
  overflow: hidden;
  padding: 0;
  border: 1px solid #dce5e1;
  border-radius: 15px;
  color: inherit;
  text-align: left;
  background: #fff;
  box-shadow: 0 7px 20px rgba(26, 58, 50, 0.04);
  cursor: pointer;
  flex-direction: column;
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}
.member-news-card:hover {
  border-color: #9fbea7;
  box-shadow: 0 16px 30px rgba(27, 69, 51, 0.11);
  transform: translateY(-3px);
}
.member-news-card:focus-visible {
  outline: 3px solid rgba(53, 121, 75, 0.28);
  outline-offset: 3px;
}

.member-news-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 104px;
  width: 100%;
  gap: 12px;
  padding: 17px 18px 15px;
  border-bottom: 1px solid #cfdfd8;
  background: #e3eee8;
}

.member-news-card-title-wrap {
  display: grid;
  min-width: 0;
  gap: 5px;
}
.member-news-card-title-wrap small {
  width: max-content;
  padding: 3px 7px;
  border-radius: 999px;
  color: #fff;
  background: #2e6943;
  font-size: 8px;
  font-weight: 780;
}

.member-news-card-company-line {
  display: grid;
  min-width: 0;
  gap: 3px;
  color: #20322b;
  font-size: 14px;
  line-height: 1.5;
}
.member-news-card-company-line strong {
  display: block;
  overflow: hidden;
  font-weight: 790;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.member-news-card-company-line em {
  display: -webkit-box;
  overflow: hidden;
  margin-left: 0;
  color: #567064;
  font-size: 10px;
  font-style: normal;
  font-weight: 650;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.member-news-card-date {
  flex: 0 0 auto;
  color: #688076;
  font-size: 8px;
  font-weight: 650;
  line-height: 1.5;
  white-space: nowrap;
}

.member-news-card-media {
  display: block;
  width: 100%;
  aspect-ratio: 16/10;
  overflow: hidden;
  border-bottom: 1px solid #e3e9e6;
  background: #eef5f2;
}
.member-news-card-media > img {
  display: block;
  width: 100%;
  height: 100%;
  padding: 10px;
  object-fit: contain;
  transition: transform 260ms ease;
}

.member-news-card:hover .member-news-card-media > img {
  transform: scale(1.025);
}

.member-news-card-empty,
.member-news-detail-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 24px;
  color: #607d70;
  text-align: center;
  background: #eef5f2;
  flex-direction: column;
}
.member-news-card-empty > i,
.member-news-detail-empty > i {
  color: #78978a;
  font-size: 26px;
}
.member-news-card-empty small,
.member-news-card-empty span,
.member-news-detail-empty small,
.member-news-detail-empty span {
  margin-top: 10px;
  color: #8b9a93;
  font-size: 9px;
}

.member-news-detail-empty strong {
  color: #3f584d;
  font-size: 13px;
  font-weight: 760;
  line-height: 1.5;
}

.member-news-card-body {
  display: flex;
  width: 100%;
  min-height: 138px;
  padding: 16px 18px 17px;
  flex: 1 1 auto;
  flex-direction: column;
}

.member-news-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.member-news-card-meta small {
  padding: 4px 7px;
  border-radius: 999px;
  color: #597067;
  background: #eef3f0;
  font-size: 8px;
  font-weight: 740;
}

.member-news-card-summary {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 11px;
  color: #5d6c66;
  font-size: 11px;
  line-height: 1.65;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.member-news-card-action {
  display: inline-flex;
  align-items: center;
  width: max-content;
  gap: 8px;
  margin-top: auto;
  padding-top: 14px;
  color: #347245;
  font-size: 10px;
  font-weight: 800;
}
.member-news-card-action i {
  font-size: 9px;
  transition: transform 180ms ease;
}

.member-news-card:hover .member-news-card-action i {
  transform: translateX(3px);
}

.member-news-detail-overlay {
  position: fixed;
  z-index: 80;
  inset: 0;
  overflow-y: auto;
  padding: 36px 20px;
  background: rgba(8, 28, 24, 0.62);
  backdrop-filter: blur(8px);
}

.member-news-detail {
  overflow: hidden;
  width: min(100%, 1050px);
  margin: 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 34px 90px rgba(4, 27, 24, 0.32);
}

.member-news-detail-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 66px;
  gap: 20px;
  padding: 13px 20px 13px 24px;
  border-bottom: 1px solid #e1e8e4;
}
.member-news-detail-topbar > div {
  display: grid;
  gap: 3px;
}
.member-news-detail-topbar > div > span:last-child {
  color: #42584e;
  font-size: 11px;
  font-weight: 730;
}
.member-news-detail-topbar button {
  min-width: 58px;
  height: 36px;
  border: 1px solid #d7e1dc;
  border-radius: 10px;
  color: #4c6057;
  background: #f5f8f6;
  cursor: pointer;
  font-size: 10px;
  font-weight: 760;
}
.member-news-detail-topbar button:hover, .member-news-detail-topbar button:focus-visible {
  border-color: #92b19a;
  color: #285f3a;
  background: #edf5ed;
}

.member-news-detail-hero {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(340px, 0.95fr);
  min-height: 350px;
  border-bottom: 1px solid #e1e8e4;
}

.member-news-detail-main-media {
  min-height: 350px;
  overflow: hidden;
  background: #edf3ef;
}
.member-news-detail-main-media > img {
  display: block;
  width: 100%;
  height: 100%;
  max-height: 460px;
  padding: 14px;
  object-fit: contain;
}

.member-news-detail-intro {
  display: flex;
  justify-content: center;
  padding: 42px 40px;
  background: #f7faf8;
  flex-direction: column;
}
.member-news-detail-intro h2 {
  margin-top: 16px;
  color: #17231e;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.3;
  letter-spacing: -0.04em;
}
.member-news-detail-intro h2 strong {
  display: block;
  font: inherit;
}
.member-news-detail-intro h2 small {
  display: block;
  margin-top: 7px;
  margin-left: 0;
  color: #52665d;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.5;
  letter-spacing: -0.02em;
}
.member-news-detail-intro > p {
  margin-top: 13px;
  color: #617169;
  font-size: 13px;
  line-height: 1.8;
}

.member-news-detail-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.member-news-detail-badges span {
  padding: 5px 9px;
  border: 1px solid #d7e4d7;
  border-radius: 999px;
  color: #487051;
  background: #fff;
  font-size: 9px;
  font-weight: 760;
}
.member-news-detail-badges span:first-child {
  border-color: #2e6943;
  color: #fff;
  background: #2e6943;
}

.member-news-detail-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 22px;
}
.member-news-detail-actions a,
.member-news-detail-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 39px;
  padding: 0 14px;
  border: 1px solid #173f36;
  border-radius: 10px;
  color: #fff;
  text-decoration: none;
  background: #173f36;
  cursor: pointer;
  font-size: 10px;
  font-weight: 770;
}
.member-news-detail-actions button {
  border-color: #cedbd5;
  color: #496058;
  background: #fff;
}

.member-news-detail-content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 310px;
  gap: 28px;
  padding: 30px;
}

.member-news-detail-main {
  display: grid;
  align-content: start;
  gap: 16px;
}

.member-news-copy-section,
.member-news-gallery,
.member-news-company-facts,
.member-news-files {
  padding: 21px;
  border: 1px solid #dce5e1;
  border-radius: 15px;
  background: #fff;
}

.member-news-copy-section > span {
  color: #397842;
  font-size: 9px;
  font-weight: 820;
  letter-spacing: 0.1em;
}
.member-news-copy-section h3 {
  margin-top: 5px;
  color: #203029;
  font-size: 14px;
  font-weight: 760;
}
.member-news-copy-section p {
  margin-top: 11px;
  color: #586961;
  font-size: 12px;
  line-height: 1.9;
  white-space: pre-line;
}

.member-news-detail-aside {
  display: grid;
  align-content: start;
  gap: 16px;
}

.member-news-subheading span {
  color: #6f867b;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.13em;
}
.member-news-subheading h3 {
  margin-top: 4px;
  color: #21312a;
  font-size: 14px;
  font-weight: 780;
}

.member-news-company-facts {
  background: #f7faf8;
}
.member-news-company-facts dl {
  display: grid;
  gap: 0;
  margin-top: 15px;
}
.member-news-company-facts dl > div {
  display: grid;
  grid-template-columns: 66px minmax(0, 1fr);
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #e1e8e4;
}
.member-news-company-facts dl > div:last-child {
  border-bottom: 0;
}
.member-news-company-facts dt {
  color: #829087;
  font-size: 9px;
  font-weight: 730;
}
.member-news-company-facts dd {
  margin: 0;
  color: #40534a;
  font-size: 10px;
  line-height: 1.55;
  word-break: break-word;
}

.member-news-files > div:nth-child(2) {
  display: grid;
  gap: 8px;
  margin-top: 14px;
}
.member-news-files a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 11px 12px;
  border: 1px solid #dfe7e3;
  border-radius: 10px;
  color: inherit;
  text-decoration: none;
  background: #fafcfb;
}
.member-news-files a:hover {
  border-color: #9ebba4;
  background: #f2f7f2;
}
.member-news-files a span {
  display: grid;
  min-width: 0;
  gap: 3px;
}
.member-news-files a strong {
  overflow: hidden;
  color: #35483f;
  font-size: 9px;
  font-weight: 720;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.member-news-files a small {
  color: #89968f;
  font-size: 8px;
}
.member-news-files a b {
  flex: 0 0 auto;
  color: #347245;
  font-size: 8px;
  font-weight: 800;
}
.member-news-files > p {
  margin-top: 14px;
  color: #87938d;
  font-size: 9px;
  line-height: 1.65;
}

.member-news-gallery > div:last-child {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}
.member-news-gallery a {
  overflow: hidden;
  aspect-ratio: 4/3;
  border: 1px solid #dfe7e3;
  border-radius: 10px;
  background: #eef3f0;
}
.member-news-gallery img {
  display: block;
  width: 100%;
  height: 100%;
  padding: 6px;
  object-fit: contain;
}

@media (max-width: 1100px) {
  .member-news-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 860px) {
  .member-news-detail-hero,
  .member-news-detail-content {
    grid-template-columns: 1fr;
  }
  .member-news-detail-main-media {
    min-height: 280px;
    max-height: 420px;
  }
  .member-news-detail-content {
    gap: 18px;
    padding: 22px;
  }
}
@media (max-width: 620px) {
  .member-news-browser {
    padding: 18px;
    border-radius: 15px;
  }
  .member-news-browser-head {
    align-items: flex-start;
    padding-bottom: 17px;
    flex-direction: column;
  }
  .member-news-grid {
    grid-template-columns: 1fr;
  }
  .member-news-detail-overlay {
    padding: 12px;
  }
  .member-news-detail {
    border-radius: 17px;
  }
  .member-news-detail-hero {
    min-height: 0;
  }
  .member-news-detail-main-media {
    min-height: 220px;
  }
  .member-news-detail-intro {
    padding: 28px 22px;
  }
  .member-news-detail-intro h2 {
    font-size: 23px;
  }
  .member-news-detail-content {
    padding: 16px;
  }
}
.procedure-browser {
  display: grid;
  grid-template-columns: 238px minmax(0, 1fr);
  align-items: start;
  gap: 22px;
}

.procedure-navigation {
  position: sticky;
  top: 90px;
  overflow: hidden;
  border: 1px solid #dae5df;
  border-radius: 18px;
  background: #fff;
}

.procedure-navigation-heading {
  padding: 22px 20px 18px;
  border-bottom: 1px solid #e6ece8;
}
.procedure-navigation-heading span {
  color: #7a8c83;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
}
.procedure-navigation-heading h2 {
  margin: 6px 0 0;
  color: #233c32;
  font-size: 15px;
  font-weight: 750;
}

.procedure-navigation-item {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
  padding: 20px 17px;
  border: 0;
  border-bottom: 1px solid #edf1ee;
  color: #52655c;
  text-align: left;
  background: #fff;
  cursor: pointer;
}
.procedure-navigation-item:last-child {
  border-bottom: 0;
}
.procedure-navigation-item > img {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  opacity: 0.75;
}
.procedure-navigation-item > span:not(.procedure-nav-arrow) {
  display: grid;
  gap: 5px;
  min-width: 0;
}
.procedure-navigation-item strong {
  color: #3c5147;
  font-size: 14px;
  font-weight: 700;
}
.procedure-navigation-item small {
  color: #88958e;
  font-size: 10px;
  line-height: 1.5;
}
.procedure-navigation-item:hover {
  background: #f7faf7;
}
.procedure-navigation-item.is-selected {
  box-shadow: inset 3px 0 #366b4b;
  background: #eff6ed;
}
.procedure-navigation-item.is-selected strong {
  color: #235138;
}
.procedure-navigation-item.is-selected > img {
  opacity: 1;
}
.procedure-navigation-item:focus-visible {
  position: relative;
  outline: 2px solid #4f825d;
  outline-offset: -3px;
}

.procedure-nav-arrow {
  margin-left: auto;
  color: #8c9c92;
  font-size: 22px;
}

.procedure-detail {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dce6e0;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 12px 34px rgba(24, 62, 43, 0.04);
}

.procedure-detail-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  padding: 28px 30px 25px;
  border-bottom: 1px solid #e4ebe6;
}
.procedure-detail-heading > div {
  min-width: 0;
}
.procedure-detail-heading .procedure-eyebrow {
  margin: 0 0 8px;
  color: #5d8267;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.08em;
}
.procedure-detail-heading h2 {
  margin: 0;
  color: #1c3429;
  font-size: 25px;
  font-weight: 780;
  letter-spacing: -0.035em;
}
.procedure-detail-heading p {
  margin: 9px 0 0;
  color: #809086;
  font-size: 12px;
  line-height: 1.6;
}
.procedure-detail-heading time {
  flex: 0 0 auto;
  margin-top: 3px;
  color: #91a096;
  font-size: 10px;
}

.procedure-detail-content {
  padding: 30px;
}

.procedure-state {
  padding: 60px 24px;
  border: 1px solid #dce6e0;
  border-radius: 18px;
  color: #718178;
  text-align: center;
  background: #fff;
}

.procedure-steps {
  display: grid;
  gap: 20px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.procedure-step {
  position: relative;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 18px;
  min-width: 0;
}
.procedure-step::after {
  position: absolute;
  z-index: 0;
  top: 46px;
  bottom: -15px;
  left: 20px;
  width: 1px;
  background: #dbe6dc;
  content: "";
}
.procedure-step:last-child::after {
  display: none;
}

.procedure-step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid #cddfcd;
  border-radius: 50%;
  color: #3b6547;
  background: #f3f8ef;
  font-size: 13px;
  font-weight: 750;
}

.procedure-step-body {
  min-width: 0;
  padding: 20px 22px;
  border: 1px solid #e0e8e2;
  border-radius: 14px;
  background: #fcfdfb;
}
.procedure-step-body h3 {
  margin: 9px 0 0;
  color: #263d30;
  font-size: 15px;
  font-weight: 720;
  line-height: 1.6;
  word-break: keep-all;
  overflow-wrap: anywhere;
}
.procedure-step-body ul {
  display: grid;
  gap: 7px;
  margin: 12px 0 0;
  padding: 0 0 0 16px;
  list-style: disc;
}
.procedure-step-body li {
  color: #758278;
  font-size: 12px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}

.procedure-step-actor {
  color: #708e74;
  font-size: 10px;
  font-weight: 700;
}

.procedure-step.is-complete .procedure-step-number {
  border-color: #355f44;
  color: #fff;
  background: #355f44;
}
.procedure-step.is-complete .procedure-step-body {
  border-color: #c8dbc8;
  background: #f0f6ed;
}

.procedure-fees {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 18px;
}

.procedure-fee-group {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #d5e3d3;
  border-radius: 16px;
}
.procedure-fee-group > header {
  padding: 22px;
  border-bottom: 1px solid #dfe9da;
  background: #f2f7ed;
}
.procedure-fee-group h3 {
  margin: 12px 0 0;
  color: #2e5135;
  font-size: 18px;
  font-weight: 750;
}
.procedure-fee-group header p {
  margin: 8px 0 0;
  color: #7b887b;
  font-size: 11px;
}
.procedure-fee-group ul {
  margin: 0;
  padding: 6px 20px;
  list-style: none;
}
.procedure-fee-group li {
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  gap: 10px;
  padding: 18px 0;
  border-bottom: 1px solid #edf1e9;
}
.procedure-fee-group li:last-child {
  border-bottom: 0;
}
.procedure-fee-group li p {
  margin: 0;
  color: #52664f;
  font-size: 12px;
  line-height: 1.9;
  overflow-wrap: anywhere;
}
.procedure-fee-group li strong {
  display: block;
  margin-top: 7px;
  color: #39603d;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.8;
  overflow-wrap: anywhere;
}
.procedure-fee-group.is-paid {
  border-color: #d9dfdf;
}
.procedure-fee-group.is-paid > header {
  border-color: #e1e6e4;
  background: #f4f6f5;
}
.procedure-fee-group.is-paid h3 {
  color: #35453e;
}
.procedure-fee-group.is-paid .procedure-fee-label {
  color: #fff;
  background: #3d5046;
}
.procedure-fee-group.is-paid .procedure-fee-check {
  color: #75877b;
}
.procedure-fee-group.is-paid li p {
  color: #5c6a60;
}
.procedure-fee-group.is-paid li strong {
  color: #283e31;
}

.procedure-fee-label {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 6px;
  color: #3d6840;
  background: #e1eed8;
  font-size: 10px;
  font-weight: 750;
}

.procedure-fee-check {
  padding-top: 2px;
  color: #75a16a;
  font-size: 12px;
}

.procedure-general, .procedure-services {
  display: grid;
  gap: 16px;
}

.procedure-general-card {
  padding: 24px;
  border: 1px solid #dce7d8;
  border-radius: 15px;
  background: #f7faf4;
}
.procedure-general-card:nth-child(2n) {
  border-color: #dde5e2;
  background: #f7f9f8;
}
.procedure-general-card h3 {
  margin: 13px 0 0;
  color: #3b5241;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.9;
  overflow-wrap: anywhere;
}
.procedure-general-card p {
  margin: 10px 0 0;
  color: #748478;
  font-size: 12px;
  line-height: 1.8;
}

.procedure-card-number {
  color: #789078;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.04em;
}

.procedure-services {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.procedure-service-card {
  min-width: 0;
  padding: 23px;
  border: 1px solid #dfe7e1;
  border-radius: 15px;
  background: #fbfcfa;
}
.procedure-service-card:last-child:nth-child(odd) {
  grid-column: 1/-1;
}
.procedure-service-card ul {
  display: grid;
  gap: 9px;
  margin: 18px 0 0;
  padding-left: 15px;
  list-style: disc;
}
.procedure-service-card li {
  color: #758277;
  font-size: 12px;
  line-height: 1.85;
  overflow-wrap: anywhere;
}

.procedure-service-heading {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.procedure-service-heading h3 {
  margin: 0;
  color: #354e3d;
  font-size: 15px;
  font-weight: 720;
  line-height: 1.6;
}

.procedure-plain-content {
  margin: 0;
  color: #596d5f;
  font-size: 14px;
  line-height: 2;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.procedure-reference-link {
  display: inline-flex;
  margin-top: 24px;
  padding: 12px 17px;
  border-radius: 9px;
  color: #fff;
  background: #355f44;
  font-size: 12px;
  text-decoration: none;
}

.procedure-attachments {
  display: grid;
  gap: 10px;
  margin-top: 24px;
}
.procedure-attachments a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 0;
  gap: 18px;
  padding: 15px;
  border: 1px solid #dfe7e1;
  border-radius: 10px;
  color: #426247;
  text-decoration: none;
  font-size: 11px;
}
.procedure-attachments a > span:first-child {
  display: grid;
  min-width: 0;
  gap: 5px;
}
.procedure-attachments strong {
  overflow-wrap: anywhere;
}
.procedure-attachments small {
  color: #8a978d;
  font-size: 10px;
}
.procedure-attachments a > span:last-child {
  flex: 0 0 auto;
}

@media (max-width: 1160px) {
  .procedure-browser {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .procedure-navigation {
    position: static;
  }
  .procedure-navigation-heading {
    display: none;
  }
  .procedure-navigation-items {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .procedure-navigation-item {
    min-width: 0;
    gap: 9px;
    padding: 18px 14px;
    border-bottom: 0;
    border-right: 1px solid #edf1ee;
  }
  .procedure-navigation-item small, .procedure-navigation-item .procedure-nav-arrow {
    display: none;
  }
}
@media (max-width: 680px) {
  .procedure-navigation-items {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .procedure-navigation-item {
    padding: 15px;
    border-bottom: 1px solid #edf1ee;
  }
  .procedure-navigation-item strong {
    font-size: 13px;
  }
  .procedure-detail-heading {
    padding: 23px 20px;
    gap: 12px;
  }
  .procedure-detail-heading h2 {
    font-size: 22px;
  }
  .procedure-detail-heading time {
    font-size: 9px;
  }
  .procedure-detail-content {
    padding: 22px 17px;
  }
  .procedure-step {
    grid-template-columns: 32px minmax(0, 1fr);
    gap: 11px;
  }
  .procedure-step::after {
    top: 38px;
    left: 15px;
  }
  .procedure-step-number {
    width: 32px;
    height: 32px;
    font-size: 11px;
  }
  .procedure-step-body {
    padding: 16px;
  }
  .procedure-step-body h3 {
    font-size: 14px;
  }
  .procedure-step-body li {
    font-size: 11px;
  }
  .procedure-fees, .procedure-services {
    grid-template-columns: 1fr;
  }
  .procedure-general-card, .procedure-service-card {
    padding: 20px;
  }
}`],
})
export class PageMarketInfoComponent implements OnInit, OnDestroy {
    public sections: { [key: string]: InfoSection } = {
        notice: {
            key: 'notice',
            title: '공지사항',
            description: 'IP Fairy의 운영 변경과 중요 안내를 확인할 수 있습니다.',
            statusMessage: '현재 등록된 공지사항이 없습니다.'
        },
        process: {
            key: 'process',
            title: '이용절차',
            description: 'IP 거래 시스템의 이용 범위와 제공 서비스, 판매·구매 절차 및 비용을 한눈에 안내합니다.',
            statusMessage: '현재 등록된 이용절차가 없습니다.'
        },
        business: {
            key: 'business',
            title: '사업정보',
            description: '10월·11월 시스템 오픈에 맞춰 지식재산·창업·사업화 관련 기관이 제공하는 유익한 정보를 취합해 업로드할 예정입니다.',
            statusMessage: '현재 등록된 사업정보가 없습니다.'
        },
        'member-news': {
            key: 'member-news',
            title: '회원소식',
            description: '10월·11월 시스템 오픈에 맞춰 기업체 회원의 회사소식, 특허획득, 수출실적 등 홍보 정보를 취합해 업로드할 예정입니다.',
            statusMessage: '현재 등록된 회원소식이 없습니다.'
        }
    };
    public section: InfoSection = this.sections.notice;
    public notices: MarketNotice[] = [];
    public selectedNotice: MarketNotice | null = null;
    public noticesLoading: boolean = false;
    public noticesError: string = '';
    public procedures: MarketNotice[] = [];
    public selectedProcedure: MarketNotice | null = null;
    public proceduresLoading: boolean = false;
    public proceduresError: string = '';
    public isAdmin: boolean = false;
    public businessInfos: MarketBusinessInfo[] = [];
    public selectedBusinessInfo: MarketBusinessInfo | null = null;
    public businessInfosLoading: boolean = false;
    public businessInfosError: string = '';
    public businessInfoModalOpen: boolean = false;
    public businessInfoSaving: boolean = false;
    public businessInfoForm: BusinessInfoForm = this.createBusinessInfoForm();
    public businessAttachmentFile: any = null;
    public businessAttachmentFileName: string = '';

    public memberNewsItems: MarketMemberNews[] = [];
    public selectedMemberNews: MarketMemberNews | null = null;
    public memberNewsDetailOpen: boolean = false;
    public memberNewsLoading: boolean = false;
    public memberNewsError: string = '';
    public memberNewsModalOpen: boolean = false;
    public memberNewsSaving: boolean = false;
    public memberNewsForm: MemberNewsForm = this.createMemberNewsForm();
    public memberPhotoFiles: any[] = [];
    public memberAttachmentFiles: any[] = [];
    public memberPhotoFileNames: string = '';
    public memberAttachmentFileNames: string = '';

    private routerSub: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        this.updateSection();
    }

    public async ngOnInit() {
        await this.service.init();
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                await this.syncSection();
            }
        });
        await this.syncSection();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    @HostListener('document:keydown.escape')
    public async onEscapeKey() {
        if (this.memberNewsDetailOpen) await this.closeMemberNewsDetail();
    }

    public async loadNotices() {
        const selectedId = this.selectedNotice?.id || '';
        this.noticesLoading = true;
        this.noticesError = '';
        await this.service.render();

        const { code, data } = await wiz.call('list_notices');
        this.noticesLoading = false;
        if (code !== 200) {
            this.notices = [];
            this.selectedNotice = null;
            this.noticesError = data?.message || '공지사항을 불러오지 못했습니다.';
            await this.service.render();
            return;
        }

        this.notices = Array.isArray(data?.items) ? data.items : [];
        this.isAdmin = false;
        this.selectedNotice = this.notices.find((item) => item.id === selectedId) || this.notices[0] || null;
        await this.service.render();
    }

    public async selectNotice(notice: MarketNotice) {
        this.selectedNotice = notice;
        await this.service.render();
    }

    public async loadProcedures() {
        const selectedId = this.selectedProcedure?.id || '';
        this.proceduresLoading = true;
        this.proceduresError = '';
        await this.service.render();

        const { code, data } = await wiz.call('list_notices', { section: 'procedure' });
        this.proceduresLoading = false;
        if (code !== 200) {
            this.procedures = [];
            this.selectedProcedure = null;
            this.proceduresError = data?.message || '이용절차를 불러오지 못했습니다.';
            await this.service.render();
            return;
        }

        this.procedures = Array.isArray(data?.items) ? data.items : [];
        this.selectedProcedure = this.procedures.find((item) => item.id === selectedId) || this.procedures[0] || null;
        await this.service.render();
    }


    public get procedureBlocks(): ProcedureBlock[] {
        const blocks: ProcedureBlock[] = [];
        for (const raw of (this.selectedProcedure?.content || '').split(/\r?\n/)) {
            const line = raw.trim();
            if (!line) continue;
            if (line.startsWith('ㅇ')) {
                const text = line.replace(/^ㅇ\s*/, '');
                const actor = text.match(/^\(([^)]+)\)\s*/);
                blocks.push({title: actor ? text.slice(actor[0].length) : text, actor: actor?.[1] || '', details: []});
            } else if (blocks.length) {
                const details = blocks[blocks.length - 1].details;
                if (line.startsWith('☞') || !details.length) details.push(line.replace(/^☞\s*/, ''));
                else details[details.length - 1] += ' ' + line;
            } else {
                return [];
            }
        }
        return blocks;
    }

    public get procedureFeeGroups(): ProcedureFeeGroup[] {
        const groups: ProcedureFeeGroup[] = [];
        for (const raw of (this.selectedProcedure?.content || '').split(/\r?\n/)) {
            const line = raw.trim();
            if (!line) continue;
            const heading = line.match(/^ㅇ\s*(무료|유료)\s*이용\s*서비스\s*(.*)$/);
            if (heading) {
                groups.push({title: heading[1] + ' 이용서비스', note: heading[2].replace(/^[（(]|[）)]$/g, ''),
                    paid: heading[1] === '유료', items: []});
            } else if (groups.length && /^[√✓•]/.test(line)) {
                const text = line.replace(/^[√✓•]\s*/, '');
                const separator = text.search(/[:：]/);
                groups[groups.length - 1].items.push({
                    title: separator < 0 ? text : text.slice(0, separator).trim(),
                    detail: separator < 0 ? '' : text.slice(separator + 1).trim()
                });
            } else {
                return [];
            }
        }
        return groups.every(group => group.items.length) ? groups : [];
    }

    public get procedureDisplayKind(): string {
        const kind = this.selectedProcedure?.procedureKind || 'text';
        if (kind === 'fees') return this.procedureFeeGroups.length ? kind : 'text';
        return ['general', 'services', 'steps'].includes(kind) && this.procedureBlocks.length ? kind : 'text';
    }

    public procedureDescription(item: MarketNotice): string {
        return {general: '이용 범위와 회원 안내', services: '판매·구매부터 기업 홍보까지',
            steps: '거래 시작부터 이전·정산까지', fees: '무료·유료 서비스 안내'}[item.procedureKind || ''] || '상세 안내 확인';
    }

    public procedureSymbol(item: MarketNotice): string {
        return {general: 'info', services: 'consult', steps: 'process', fees: 'price'}[item.procedureKind || ''] || 'info';
    }

    public async selectProcedure(item: MarketNotice) {
        this.selectedProcedure = item;
        await this.service.render();
    }

    public async loadBusinessInfos() {
        const selectedId = this.selectedBusinessInfo?.id || '';
        this.businessInfosLoading = true;
        this.businessInfosError = '';
        await this.service.render();

        const { code, data } = await wiz.call('list_business_infos');
        this.businessInfosLoading = false;
        if (code !== 200) {
            this.businessInfos = [];
            this.selectedBusinessInfo = null;
            this.businessInfosError = data?.message || '사업정보를 불러오지 못했습니다.';
            await this.service.render();
            return;
        }

        this.businessInfos = Array.isArray(data?.items) ? data.items : [];
        this.isAdmin = false;
        this.selectedBusinessInfo = this.businessInfos.find((item) => item.id === selectedId) || this.businessInfos[0] || null;
        await this.service.render();
    }

    public async selectBusinessInfo(item: MarketBusinessInfo) {
        this.selectedBusinessInfo = item;
        await this.service.render();
    }

    public async openBusinessInfoModal() {
        if (!this.isAdmin) return;
        this.businessInfoForm = this.createBusinessInfoForm();
        this.businessAttachmentFile = null;
        this.businessAttachmentFileName = '';
        this.businessInfoModalOpen = true;
        await this.service.render();
    }

    public async closeBusinessInfoModal() {
        if (this.businessInfoSaving) return;
        this.businessInfoModalOpen = false;
        this.businessAttachmentFile = null;
        this.businessAttachmentFileName = '';
        await this.service.render();
    }

    public async onBusinessAttachmentSelect(event: any) {
        const file = event?.target?.files?.[0];
        if (!file) {
            this.businessAttachmentFile = null;
            this.businessAttachmentFileName = '';
            await this.service.render();
            return;
        }
        if (Number(file.size || 0) > 10 * 1024 * 1024) {
            event.target.value = '';
            this.businessAttachmentFile = null;
            this.businessAttachmentFileName = '';
            await this.service.modal.error('첨부파일은 10MB 이하만 업로드할 수 있습니다.');
            return;
        }
        this.businessAttachmentFile = file;
        this.businessAttachmentFileName = String(file.name || '');
        await this.service.render();
    }

    public async submitBusinessInfo() {
        const organization = this.businessInfoForm.organization.trim();
        const title = this.businessInfoForm.title.trim();
        const category = this.businessInfoForm.category.trim();
        const content = this.businessInfoForm.content.trim();
        if (!organization || !title || !category || !content) {
            await this.service.modal.error('제공 기관, 제목, 지원 구분과 설명을 모두 입력해주세요.');
            return;
        }

        this.businessInfoSaving = true;
        await this.service.render();
        const { code, data } = await wiz.call('create_business_info', {
            payload: JSON.stringify({
                organization,
                title,
                category,
                content,
                pinned: this.businessInfoForm.pinned
            })
        });
        if (code !== 200 || !data?.item?.id) {
            this.businessInfoSaving = false;
            await this.service.modal.error(data?.message || '사업정보를 저장하지 못했습니다.');
            await this.service.render();
            return;
        }

        if (this.businessAttachmentFile) {
            const formData = new FormData();
            formData.append('file', this.businessAttachmentFile);
            const upload: any = await this.service.file.upload(
                `${wiz.url('upload_business_info_attachment')}?id=${encodeURIComponent(data.item.id)}`,
                formData
            );
            if (!upload || upload.code !== 200) {
                this.businessInfoSaving = false;
                this.businessInfoModalOpen = false;
                await this.loadBusinessInfos();
                await this.service.modal.error(upload?.data?.message || '사업정보는 저장되었지만 첨부파일 업로드에 실패했습니다.');
                return;
            }
        }

        this.businessInfoSaving = false;
        this.businessInfoModalOpen = false;
        this.businessAttachmentFile = null;
        this.businessAttachmentFileName = '';
        await this.loadBusinessInfos();
        await this.service.modal.success('사업정보가 등록되었습니다.');
    }

    public async toggleBusinessInfoPin(item: MarketBusinessInfo) {
        if (!this.isAdmin) return;
        const pinned = !item.pinned;
        const { code, data } = await wiz.call('toggle_business_info_pin', {
            payload: JSON.stringify({ id: item.id, pinned })
        });
        if (code !== 200) {
            await this.service.modal.error(data?.message || '사업정보 고정 상태를 변경하지 못했습니다.');
            return;
        }
        await this.loadBusinessInfos();
    }

    public businessAttachmentUrl(attachment: NoticeAttachment | null) {
        return attachment?.downloadUrl || '';
    }

    public async loadMemberNews() {
        const selectedId = this.selectedMemberNews?.id || '';
        this.memberNewsLoading = true;
        this.memberNewsError = '';
        await this.service.render();

        const { code, data } = await wiz.call('list_member_news');
        this.memberNewsLoading = false;
        if (code !== 200) {
            this.memberNewsItems = [];
            this.selectedMemberNews = null;
            this.memberNewsError = data?.message || '회원소식을 불러오지 못했습니다.';
            await this.service.render();
            return;
        }

        this.memberNewsItems = Array.isArray(data?.items) ? data.items : [];
        this.isAdmin = false;
        this.selectedMemberNews = this.memberNewsDetailOpen
            ? this.memberNewsItems.find((item) => item.id === selectedId) || null
            : null;
        if (!this.selectedMemberNews) this.memberNewsDetailOpen = false;
        await this.service.render();
    }

    public async selectMemberNews(item: MarketMemberNews) {
        this.selectedMemberNews = item;
        this.memberNewsDetailOpen = true;
        await this.service.render();
    }

    public async closeMemberNewsDetail() {
        this.memberNewsDetailOpen = false;
        await this.service.render();
    }

    public async openMemberNewsModal() {
        if (!this.isAdmin) return;
        this.memberNewsForm = this.createMemberNewsForm();
        this.clearMemberMediaFiles();
        this.memberNewsModalOpen = true;
        await this.service.render();
    }

    public async closeMemberNewsModal() {
        if (this.memberNewsSaving) return;
        this.memberNewsModalOpen = false;
        this.clearMemberMediaFiles();
        await this.service.render();
    }

    public async onMemberMediaSelect(event: any, kind: 'photo' | 'attachment') {
        const selected: any[] = [];
        const files = event?.target?.files;
        for (let index = 0; index < Number(files?.length || 0); index += 1) {
            selected.push(files[index]);
        }
        if (selected.length > 5) {
            event.target.value = '';
            await this.service.modal.error('사진과 첨부자료는 각각 5개까지 선택할 수 있습니다.');
            return;
        }
        if (selected.some((file) => Number(file?.size || 0) > 10 * 1024 * 1024)) {
            event.target.value = '';
            await this.service.modal.error('파일은 개별 10MB 이하만 업로드할 수 있습니다.');
            return;
        }
        const names = selected.map((file) => String(file?.name || '')).filter(Boolean).join(', ');
        if (kind === 'photo') {
            this.memberPhotoFiles = selected;
            this.memberPhotoFileNames = names;
        } else {
            this.memberAttachmentFiles = selected;
            this.memberAttachmentFileNames = names;
        }
        await this.service.render();
    }

    public async submitMemberNews() {
        const companyName = this.memberNewsForm.companyName.trim();
        const region = this.memberNewsForm.region.trim();
        const industry = this.memberNewsForm.industry.trim();
        const summary = this.memberNewsForm.summary.trim();
        const introduction = this.memberNewsForm.introduction.trim();
        if (!companyName || !region || !industry || !summary || !introduction) {
            await this.service.modal.error('기업명, 지역, 업종, 홍보 요약과 회사 소개를 모두 입력해주세요.');
            return;
        }

        this.memberNewsSaving = true;
        await this.service.render();
        const { code, data } = await wiz.call('create_member_news', {
            payload: JSON.stringify({
                ...this.memberNewsForm,
                companyName,
                region,
                industry,
                summary,
                introduction
            })
        });
        if (code !== 200 || !data?.item?.id) {
            this.memberNewsSaving = false;
            await this.service.modal.error(data?.message || '회원소식을 저장하지 못했습니다.');
            await this.service.render();
            return;
        }

        const photoError = await this.uploadMemberMedia(data.item.id, 'photo', this.memberPhotoFiles);
        const attachmentError = photoError ? '' : await this.uploadMemberMedia(data.item.id, 'attachment', this.memberAttachmentFiles);
        if (photoError || attachmentError) {
            this.memberNewsSaving = false;
            this.memberNewsModalOpen = false;
            await this.loadMemberNews();
            await this.service.modal.error(photoError || attachmentError);
            return;
        }

        this.memberNewsSaving = false;
        this.memberNewsModalOpen = false;
        this.clearMemberMediaFiles();
        await this.loadMemberNews();
        await this.service.modal.success('회원소식이 등록되었습니다.');
    }

    public async toggleMemberNewsPin(item: MarketMemberNews) {
        if (!this.isAdmin) return;
        const pinned = !item.pinned;
        const { code, data } = await wiz.call('toggle_member_news_pin', {
            payload: JSON.stringify({ id: item.id, pinned })
        });
        if (code !== 200) {
            await this.service.modal.error(data?.message || '회원소식 고정 상태를 변경하지 못했습니다.');
            return;
        }
        await this.loadMemberNews();
    }

    public memberNewsMediaUrl(item: MarketMemberNews | null, media: MemberMedia | null) {
        if (!item || !media) return '';
        const query = `id=${encodeURIComponent(item.id)}&mediaId=${encodeURIComponent(media.id)}`;
        return `${wiz.url('download_member_news_media')}?${query}`;
    }

    public memberNewsTagline(item: MarketMemberNews | null) {
        const summary = String(item?.summary || '').trim();
        if (!summary || summary === '…' || summary === '...') return '';
        const bracketedName = `[${String(item?.companyName || '').trim()}]`;
        if (summary === item?.companyName || summary === bracketedName || summary === `${bracketedName} …`) return '';
        return summary;
    }

    public memberNewsIntroduction(item: MarketMemberNews | null) {
        const introduction = String(item?.introduction || '').trim();
        if (introduction && introduction !== '…' && introduction !== '...') return introduction;
        if (item?.industry) return `${item.industry} 분야의 기업 정보와 최신 소식입니다.`;
        return '회원사의 기업 정보와 최신 소식을 확인해보세요.';
    }

    public formatFileSize(size: number) {
        const bytes = Number(size || 0);
        if (!bytes) return '';
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${Math.ceil(bytes / 1024)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    }

    private async syncSection() {
        this.updateSection();
        if (this.section.key === 'notice') {
            await this.loadNotices();
            return;
        }
        if (this.section.key === 'process') {
            await this.loadProcedures();
            return;
        }
        if (this.section.key === 'business') {
            await this.loadBusinessInfos();
            return;
        }
        if (this.section.key === 'member-news') {
            await this.loadMemberNews();
            return;
        }
        await this.service.render();
    }

    private updateSection() {
        const sectionKey = String(WizRoute.segment.section || 'notice');
        this.section = this.sections[sectionKey] || this.sections.notice;
    }

    private createBusinessInfoForm(): BusinessInfoForm {
        return {
            organization: '',
            title: '',
            category: '',
            content: '',
            pinned: false
        };
    }

    private createMemberNewsForm(): MemberNewsForm {
        return {
            companyName: '',
            region: '',
            industry: '',
            summary: '',
            representative: '',
            address: '',
            contact: '',
            introduction: '',
            achievements: '',
            recentNews: '',
            homepage: '',
            pinned: false
        };
    }

    private clearMemberMediaFiles() {
        this.memberPhotoFiles = [];
        this.memberAttachmentFiles = [];
        this.memberPhotoFileNames = '';
        this.memberAttachmentFileNames = '';
    }

    private async uploadMemberMedia(itemId: string, kind: 'photo' | 'attachment', files: any[]) {
        if (!files.length) return '';
        const formData = new FormData();
        files.forEach((file) => formData.append('file', file));
        const upload: any = await this.service.file.upload(
            `${wiz.url('upload_member_news_media')}?id=${encodeURIComponent(itemId)}&kind=${kind}`,
            formData
        );
        if (upload && upload.code === 200) return '';
        const label = kind === 'photo' ? '사진' : '첨부자료';
        return upload?.data?.message || `회원소식은 저장되었지만 ${label} 업로드에 실패했습니다.`;
    }
}

export default PageMarketInfoComponent;